(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/feed-calculator"],{

/***/ "./src/assets/js/feed-calculator.js":
/*!******************************************!*\
  !*** ./src/assets/js/feed-calculator.js ***!
  \******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var FeedCalculatorForm = /*#__PURE__*/function (_HTMLElement) {
  function FeedCalculatorForm() {
    var _this;
    _classCallCheck(this, FeedCalculatorForm);
    _this = _callSuper(this, FeedCalculatorForm);
    _this.form = _this.querySelector('form');
    _this.weight = _this.querySelector('#weight');
    _this.food = _this.querySelector('#age');
    _this.breed = _this.querySelector('#breed');
    _this.breedValue = _this.querySelector('#breed');
    _this.weightCondition = _this.querySelector('#weightCondition');
    _this.kastration = _this.querySelector('#kastration');
    _this.activity = _this.querySelector('#activity');
    _this.dogName = _this.querySelector('#dogName');
    _this.snack = _this.querySelector('#snack');
    _this.dogWetFood = _this.querySelector('#dogWetFood');
    _this.result1 = _this.querySelector('#result1');
    _this.wetFoodResults = _this.querySelector('.wet-food-results');
    _this.dryFoodResults = _this.querySelector('.dry-food-results');
    _this.hierHeading = _this.querySelector('#hierHeading');
    _this.sectId = _this.dataset.sectid;
    _this.blockData = window['imageSlidesData' + _this.sectId];
    _this.resultsModal = _this.querySelector('.results-modal');
    _this.upsellCards = _this.querySelectorAll('.cart-upsell-item');
    _this.upsellProducts = _this.querySelector('.results-modal__products-upsell-products');
    _this.gewichtResults = _this.querySelector('.gewicht-results');
    _this.alterResults = _this.querySelector('.alter-results');
    _this.rasseResults = _this.querySelector('.rasse-results');
    _this.aktivitatResults = _this.querySelector('.aktivitat-results');
    _this.wetFoodQuestion = _this.querySelector('.wetfood-question');
    _this.yearText = _this.dataset.yearname;
    return _this;
  }
  _inherits(FeedCalculatorForm, _HTMLElement);
  return _createClass(FeedCalculatorForm, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
      this.repositionElements();
      // this.ensureInitialProductInCart();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        _this2.submitForm();
      });
      this.breed.addEventListener('change', function (event) {
        var selectedValue = event.target.value;
        if (selectedValue.includes('Bulldog') || selectedValue.includes('Minis') || selectedValue.includes('Retriever')) {
          _this2.wetFoodQuestion.classList.remove('tw-hidden');
        } else {
          _this2.wetFoodQuestion.classList.add('tw-hidden');
        }
      });
    }
  }, {
    key: "repositionElements",
    value: function repositionElements() {
      var mobileContainer = this.querySelector('.mobile-container');
      var resultsModalImage = this.querySelector('.results-modal__image');
      var wrapperContainer = this.querySelectorAll('.results-modal__wrapper-container')[1];
      var resultsModalWrapperMetaInfo = this.querySelector('.results-modal__wrapper-meta-info');
      var firstWrapperContainer = this.querySelector('.results-modal__wrapper-container');

      // Check if we are on a mobile device (e.g., width less than 768px)
      if (window.innerWidth < 1023) {
        // Move elements for mobile layout
        if (resultsModalImage && mobileContainer) {
          mobileContainer.appendChild(resultsModalImage);
        }
        if (wrapperContainer && mobileContainer) {
          mobileContainer.appendChild(wrapperContainer);
        }
      } else {
        // Move elements back for desktop layout
        if (resultsModalImage && resultsModalWrapperMetaInfo) {
          resultsModalWrapperMetaInfo.parentNode.insertBefore(resultsModalImage, resultsModalWrapperMetaInfo);
        }
        if (wrapperContainer && firstWrapperContainer) {
          firstWrapperContainer.parentNode.insertBefore(wrapperContainer, firstWrapperContainer.nextSibling);
        }
      }
    }
  }, {
    key: "initQuickAdd",
    value: function initQuickAdd() {
      new theme.QuickAdd(this.upsellProducts);
      new theme.QuickShop(this.upsellProducts);
    }
  }, {
    key: "showResultsModal",
    value: function showResultsModal() {
      this.resultsModal.classList.remove('tw-hidden');
    }
  }, {
    key: "replaceDogsName",
    value: function replaceDogsName(dogName) {
      this.querySelectorAll('.dog_name_placeholder').forEach(function (placeholder) {
        placeholder.textContent = dogName;
      });
    }
  }, {
    key: "hideAllUpsells",
    value: function hideAllUpsells() {
      this.upsellCards.forEach(function (upsellCard) {
        upsellCard.style.display = 'none';
      });
    }
  }, {
    key: "showUpsell",
    value: function showUpsell(upsellHandle) {
      this.querySelector(".item-".concat(upsellHandle)).style.display = 'grid';
    }
  }, {
    key: "scrollToResultsModal",
    value: function scrollToResultsModal() {
      var resultsModal = this.querySelector('.results-modal');
      if (resultsModal) {
        resultsModal.scrollIntoView({
          behavior: 'smooth'
        });
      } else {
        console.error('Results modal not found');
      }
    }
  }, {
    key: "replaceImage",
    value: function replaceImage(imageSrc) {
      this.querySelector('.results-modal__image').style.display = 'block';
      this.querySelector('.results-modal__image').src = imageSrc;
    }
  }, {
    key: "hideImage",
    value: function hideImage() {
      this.querySelector('.results-modal__image').style.display = 'none';
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      var _this3 = this;
      var weight = parseFloat(this.weight.value, 10);
      var food = this.food.value;
      var breed = this.breed.value;
      var breedValue = this.breed.value;
      var weightCondition = this.weightCondition.value;
      var kastration = this.kastration.value;
      var activity = this.activity.value;
      var dogName = this.dogName.value;
      var snack = this.snack.value;
      var dogWetFood = this.dogWetFood.value;
      if (kastration == 'Nicht kastriert') {
        kastration = 0;
      } else {
        kastration = -10;
      }
      if (activity == 'Wenig (z.B. 1 Stunde spazieren gehen an der Leine / Tag)') {
        activity = 0;
      } else if (activity == 'Mittel (z.B. 2 Stunden spielen / Tag)') {
        activity = 20;
      } else {
        activity = 50;
      }
      if (food == '< 2 Jahre') {
        food = 0.04;
      } else if (food == '2-7 Jahre') {
        food = 0;
      } else {
        food = -0.10;
      }
      if (weightCondition == 'Deutlich übergewichtig') {
        weightCondition = -13;
      } else if (weightCondition == 'Etwas übergewichtig') {
        weightCondition = -7;
      } else if (weightCondition == 'Genau richtig') {
        weightCondition = 0;
      } else if (weightCondition == 'Etwas untergewichtig') {
        weightCondition = 10;
      } else {
        weightCondition = 20;
      }
      if (breed == 'Golden Retriever' || breed == 'Labrador Retriever' || breed == 'Flat Coated Retriever' || breed == 'Andere Bulldogge' || breed == 'Anderer Retriever' || breed == 'Französische Bulldoggen' || breed == 'Old English Bulldog' || breed == 'American Bulldog' || breed == 'Continental Bulldog' || breed == 'Mops' || breed == 'Beagle' || breed == 'Cavalier King Charles Spaniel' || breed == 'West Highland White Terrier' || breed == 'Welsh Corgi') {
        breed = -5;
      } else {
        breed = 0;
      }
      var D6;
      if (weight >= 2 && weight < 4) {
        D6 = 0.41;
      } else if (weight >= 4 && weight < 8) {
        D6 = 0.33;
      } else if (weight >= 8 && weight < 13) {
        D6 = 0.28;
      } else if (weight >= 13 && weight < 18) {
        D6 = 0.25;
      } else if (weight >= 18 && weight < 23) {
        D6 = 0.23;
      } else if (weight >= 23 && weight < 28) {
        D6 = 0.22;
      } else if (weight >= 28 && weight < 33) {
        D6 = 0.21;
      } else if (weight >= 33 && weight < 38) {
        D6 = 0.20;
      } else if (weight >= 38 && weight < 46) {
        D6 = 0.20;
      } else if (weight >= 46 && weight < 56) {
        D6 = 0.19;
      } else if (weight >= 56 && weight < 71) {
        D6 = 0.18;
      } else {
        D6 = 0.17;
      }
      var weightOriginal = weight;
      var test = parseFloat(100 + breed + weightCondition + kastration + activity) / 100;
      var D12 = ((D6 + food) * parseFloat(100 + breed + weightCondition + kastration + activity) / 100).toFixed(2);
      var F12 = (D12 * weightOriginal).toFixed(2);
      var kgSeventyFive = Math.pow(weightOriginal, 0.75);
      var MjHalf = kgSeventyFive * 0.5;
      var N12;
      if (F12 > MjHalf * 1.25) {
        N12 = MjHalf * 1.25;
      } else {
        N12 = F12;
      }
      var P12;
      if (F12 < MjHalf * 0.75) {
        P12 = MjHalf * 0.75;
      } else {
        P12 = F12;
      }
      var R12;
      if (N12 > MjHalf) {
        R12 = N12;
      } else {
        R12 = P12;
      }
      console.log('rrr', snack);
      var caloriesSnack;
      var caloriesD;
      var caloriesE;
      var calories;
      var wetCalories;
      if (snack) {
        if (breedValue.includes('Retriever')) {
          caloriesSnack = 344;
        } else if (breedValue.includes('Bulldog')) {
          caloriesSnack = 349;
        } else if (breedValue.includes('Kleine')) {
          caloriesSnack = 357;
        } else if (breedValue.includes('Hütehunde')) {
          caloriesSnack = 338;
        } else if (breedValue.includes('Minis')) {
          caloriesSnack = 314;
        } else {
          caloriesSnack = 349;
        }
        caloriesD = caloriesSnack / 238.85;
        caloriesE = caloriesD / 50;
      }
      if (breedValue.includes('Retriever')) {
        calories = 379;
        wetCalories = 0.53;
      } else if (breedValue.includes('Bulldog')) {
        calories = 371;
        wetCalories = 0.53433;
      } else if (breedValue.includes('Kleine')) {
        calories = 379;
      } else if (breedValue.includes('Hütehunde')) {
        calories = 371;
      } else if (breedValue.includes('Minis')) {
        calories = 391;
        wetCalories = 0.43;
      } else if (breedValue.includes('Molosser')) {
        calories = 378;
      } else if (breedValue.includes('Jagdhunde')) {
        calories = 392;
      } else {
        calories = 391;
      }
      var T12;
      T12 = R12 - snack * caloriesE;
      var feed;
      var feedWet;
      var wetP;
      var dryP;
      if (dogWetFood) {
        console.log(Number(dogWetFood), 'ddd');
        dryP = Number(dogWetFood) / 100;
        wetP = 1 - Number(dogWetFood) / 100;
      }
      feed = Math.ceil(R12 * 238.85 / calories * 100);
      if (snack) {
        feed = Math.ceil(T12 * 238.85 / calories * 100);
      }
      if (snack) {
        feedWet = Math.ceil(T12 * wetP / wetCalories * 100);
      } else {
        feedWet = Math.ceil(R12 * wetP / wetCalories * 100);
      }
      if (snack) {
        feed = Math.ceil(T12 * dryP / caloriesD * 100);
      } else {
        feed = Math.ceil(R12 * dryP / (calories / 238.5) * 100);
      }
      feedWet = Math.ceil(T12 * wetP / wetCalories * 100);
      feed = Math.ceil(T12 * dryP / (calories / 238.5) * 100);
      console.log(R12, 'calories', calories, 'caloriesSnack', caloriesSnack, 'caloriesD', caloriesD, 'T12', T12, feed, 'feedwet', feedWet);
      if (feedWet > 0) {
        this.wetFoodResults.style.display = 'block';
      } else {
        this.wetFoodResults.style.display = 'none';
      }
      if (feed > 0) {
        this.dryFoodResults.style.display = 'block';
      } else {
        this.dryFoodResults.style.display = 'none';
      }
      if (breedValue.includes('Bulldog') || breedValue.includes('Minis') || breedValue.includes('Retriever')) {
        this.wetFoodResults.style.display = 'block';
      } else {
        this.wetFoodResults.style.display = 'none';
      }
      this.dryFoodResults.querySelector('.results-holder').innerHTML = feed + ' g';
      this.wetFoodResults.querySelector('.results-holder').innerHTML = feedWet + ' g';

      // this.hierHeading.textContent = 'Hier kommst du zum Futter für ' + dogName;

      var alter = this.querySelector('#age').value;
      alter = alter.replace('< ', '').replace('> ', '').split(' ')[0];
      this.gewichtResults.innerHTML = weight + ' kg';
      this.alterResults.innerHTML = alter + ' ' + this.yearText;
      var rasseValue = this.breed.value;
      var rasseText = document.querySelector("[value=\"".concat(rasseValue, "\"]")).textContent;
      this.rasseResults.innerHTML = rasseText;
      var activityValue = this.activity.value;
      var acitivtyText = document.querySelector("[value=\"".concat(activityValue, "\"]")).textContent;
      this.aktivitatResults.innerHTML = acitivtyText;
      this.replaceDogsName(dogName);
      this.hideAllUpsells();
      this.blockData.forEach(function (item) {
        // Show upsell for each product

        console.log('item title', item.title);
        if (breedValue.includes(item.title)) {
          if (item.products && item.products.length > 0) {
            item.products.forEach(function (product) {
              _this3.showUpsell(product.handle);
            });
          }
          _this3.querySelector('[data-product-handle="ravishing-retrievers-nassfutter"]') ? _this3.querySelector('[data-product-handle="ravishing-retrievers-nassfutter"]').style.display = 'none' : '';
          _this3.querySelector('[data-product-handle="beautiful-bulldogs-nassfutter"]') ? _this3.querySelector('[data-product-handle="beautiful-bulldogs-nassfutter"]').style.display = 'none' : _this3.querySelector('[data-product-handle="beautiful-bulldogs-patees"]') ? _this3.querySelector('[data-product-handle="beautiful-bulldogs-patees"]').style.display = 'none' : '';
          _this3.querySelector('[data-product-handle="marvelous-minis-nassfutter-chicken"]') ? _this3.querySelector('[data-product-handle="marvelous-minis-nassfutter-chicken"]').style.display = 'none' : '';
          if (_this3.breed.value.includes('Bulldog') && _this3.dogWetFood.value < 100 && _this3.dogWetFood.value > 0) {
            _this3.querySelector('[data-product-handle="beautiful-bulldogs-nassfutter"]') ? _this3.querySelector('[data-product-handle="beautiful-bulldogs-nassfutter"]').style.display = 'grid' : _this3.querySelector('[data-product-handle="beautiful-bulldogs-patees"]') ? _this3.querySelector('[data-product-handle="beautiful-bulldogs-patees"]').style.display = 'grid' : '';
          } else if (_this3.breed.value.includes('Minis') && _this3.dogWetFood.value < 100 && _this3.dogWetFood.value > 0) {
            _this3.querySelector('[data-product-handle="marvelous-minis-nassfutter-chicken"]') ? _this3.querySelector('[data-product-handle="marvelous-minis-nassfutter-chicken"]').style.display = 'grid' : '';
          } else if (_this3.breed.value.includes('Retriever') && _this3.dogWetFood.value < 100 && _this3.dogWetFood.value > 0) {
            _this3.querySelector('[data-product-handle="ravishing-retrievers-nassfutter"]') ? _this3.querySelector('[data-product-handle="ravishing-retrievers-nassfutter"]').style.display = 'grid' : '';
          }

          // Replace or hide image based on the item's image property
          if (item.image && item.image !== '') {
            _this3.replaceImage(item.image);
          } else {
            _this3.hideImage();
          }
        }
      });
      this.initQuickAdd();
      this.showResultsModal();
      this.scrollToResultsModal();
    }
  }, {
    key: "init",
    value: function init() {
      var _this4 = this;
      this.setEventListeners();
      window.addEventListener('resize', function () {
        return _this4.repositionElements();
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('feed-calculator-form')) {
  customElements.define('feed-calculator-form', FeedCalculatorForm);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/feed-calculator.js"));
/******/ }
]);